/**
 * Enum for Package type values.
 * @readonly
 * @enum {number}
 */
export enum EPackageType {
  INVALID = 0,
  PHONE_CREDIT = 1,
  DATA = 2,
  VOICE = 4,
  SMS = 8,
  ROAMING = 16,
  SOCIAL_NETWORK = 32,
  MICRO_CREDIT = 64,
  UNLIMITED = 128,
  OTHER = 256,
  ENTERTAINMENT = 512,
  BULK = 1024,

  DATA_VOICE = 6,
  DATA_SMS = 10,
  SMS_VOICE = 12,
  DATA_VOICE_SMS = 14,

  ROAMING_DATA = 18,
  ROAMING_VOICE = 20,
  ROAMING_SMS = 24,

  SOCIAL_NETWORK_DATA = 34,
  SOCIAL_NETWORK_VOICE = 36,
  SOCIAL_NETWORK_SMS = 40,

  DATA_VOICE_SMS_SOCIAL_NETWORK = 46,

  MICRO_CREDIT_DATA = 66,
  MICRO_CREDIT_VOICE = 68,
  MICRO_CREDIT_SMS = 72,
  MICRO_CREDIT_SOCIAL_NETWORK = 96,

  DATA_UNLIMITED = 130,
  DATA_VOICE_SMS_ENTERTAINMENT = 526,
  ALL_INCLUSIVE_OTHER = 270,
  DATA_BULK = 1026,
  TOGGLE_BULK = 1280
}
